import {
  defFetchList,
  defFetchOne,
  defUpdateOne,
  defUploadCertFile,
  defDeleteCert,
  defCreateOrdersNotify
} from '@/api/default'
import request from '@/api/request'

const BASE_PATH = '/orders'

export function fetchList (query) {
  return defFetchList(BASE_PATH, query)
}

export function fetchOne (id) {
  return defFetchOne(BASE_PATH, id)
}

export function updateOne (id, data) {
  return defUpdateOne(BASE_PATH, id, data)
}

export function uploadCertFile (id, data, config) {
  return defUploadCertFile(BASE_PATH, id, data, config)
}

export function deleteCert (id) {
  return defDeleteCert(BASE_PATH, id)
}

export function createOrdersNotify (id, data) {
  return defCreateOrdersNotify(BASE_PATH, { ...data, orders_id: id })
}

export function getAttendeeOrderLink (id) {
  return request({
    url: `${BASE_PATH}/${id}/attendee_link`,
    method: 'get'
  })
}

export function getArrivalTime (id, params) {
  return request({
    url: `${BASE_PATH}/${id}/arrival_time`,
    method: 'get',
    params: params
  })
}

export function getRefundAmount (id, params, signal) {
  return request({
    url: `${BASE_PATH}/${id}/refund_amount`,
    method: 'get',
    params: params,
    signal: signal
  })
}

export function updateOrdersNotes (id, data) {
  return request({
    url: `${BASE_PATH}/${id}/note`,
    method: 'put',
    data: data
  })
}
